import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { CategoriesList } from "../../../../components/categoriesList/CategoriesList";
import { CATEGORY_STATUS } from "../../../../components/categoryToggle/CategoryToggle";
import { getCategoriesList } from "../../../../store/categories";

import "./SchedulerCategories.scss";
import {
  changeCategories,
  getBlockedCategories,
} from "../../../../store/schedules";
import { useSchedulerContext } from "../SchedulerContext";

export const SchedulerCategories = () => {
  const dispatch = useDispatch();
  const { profileId } = useSchedulerContext();
  const blockedCategories = useSelector(getBlockedCategories(profileId));
  const fetchedCategories = useSelector(getCategoriesList);

  const categories = useMemo(() => {
    return fetchedCategories.map((category) => {
      const status = blockedCategories.includes(category.name)
        ? CATEGORY_STATUS.BLOCKED
        : CATEGORY_STATUS.ALLOWED;

      return {
        ...category,
        status,
      };
    });
  }, [fetchedCategories, blockedCategories]);

  const allow = (category) => {
    const categoriesToAllow = Array.isArray(category) ? category : [category];
    const updatedCategories = blockedCategories.filter(
      (cat) => !categoriesToAllow.includes(cat),
    );
    dispatch(changeCategories(updatedCategories, profileId));
  };

  const block = (category) => {
    const categoriesToBlock = Array.isArray(category) ? category : [category];
    const updatedCategories = [...blockedCategories, ...categoriesToBlock];
    dispatch(changeCategories(updatedCategories, profileId));
  };

  return (
    <div className="scheduler-categories">
      <CategoriesList
        allCategories={categories}
        blockedCategories={blockedCategories}
        allowAction={allow}
        blockAction={block}
      />
    </div>
  );
};
